<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc" role="doc-toc">
<h1 id="toc-title">The Mannequin House</h1>
<ol class="toc">
<li>
<span href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li id="title_page">
<a href="#/text/title_page">Title Page</a>
</li>
<li id="toc-li-1">
<a href="#/text/ch001#authors-note">Author’s Note</a>
</li>
<li id="toc-li-2">
<a href="#/text/ch002#london-april-1914">London, April 1914</a>
</li>
<li id="toc-li-3">
<a href="#/text/ch003#the-house-of-blackley">The House of Blackley</a>
</li>
<li id="toc-li-4">
<a href="#/text/ch004#the-locked-door">The Locked Door</a>
</li>
<li id="toc-li-5">
<a href="#/text/ch005#the-usual-misunderstanding">The Usual Misunderstanding</a>
</li>
<li id="toc-li-6">
<span href="#/text/ch006#speak-of-the-devil" title="Link target outside of Sample">Speak of the Devil</span>
</li>
<li id="toc-li-7">
<span href="#/text/ch007#hear-no-evil" title="Link target outside of Sample">Hear No Evil</span>
</li>
<li id="toc-li-8">
<span href="#/text/ch008#the-weeping-mannequin" title="Link target outside of Sample">The Weeping Mannequin</span>
</li>
<li id="toc-li-9">
<span href="#/text/ch009#the-secret-letters" title="Link target outside of Sample">The Secret Letters</span>
</li>
<li id="toc-li-10">
<span href="#/text/ch010#the-spare-room" title="Link target outside of Sample">The Spare Room</span>
</li>
<li id="toc-li-11">
<span href="#/text/ch011#the-monkey-in-the-tree" title="Link target outside of Sample">The Monkey in the Tree</span>
</li>
<li id="toc-li-12">
<span href="#/text/ch012#the-mask-slips" title="Link target outside of Sample">The Mask Slips</span>
</li>
<li id="toc-li-13">
<span href="#/text/ch013#obstructions" title="Link target outside of Sample">Obstructions</span>
</li>
<li id="toc-li-14">
<span href="#/text/ch014#conversations-with-mannequins" title="Link target outside of Sample">Conversations With Mannequins</span>
</li>
<li id="toc-li-15">
<span href="#/text/ch015#locks-clocks-and-mechanical-contrivances" title="Link target outside of Sample">Locks, Clocks and Mechanical Contrivances</span>
</li>
<li id="toc-li-16">
<span href="#/text/ch016#the-african-grey" title="Link target outside of Sample">The African Grey</span>
</li>
<li id="toc-li-17">
<span href="#/text/ch017#lessons-learnt" title="Link target outside of Sample">Lessons Learnt</span>
</li>
<li id="toc-li-18">
<span href="#/text/ch018#the-eyes-of-miss-dillard" title="Link target outside of Sample">The Eyes of Miss Dillard</span>
</li>
<li id="toc-li-19">
<span href="#/text/ch019#a-new-broom" title="Link target outside of Sample">A New Broom</span>
</li>
<li id="toc-li-20">
<span href="#/text/ch020#the-medical-examiners-report" title="Link target outside of Sample">The Medical Examiner’s Report</span>
</li>
<li id="toc-li-21">
<span href="#/text/ch021#a-chip-off-the-old-block" title="Link target outside of Sample">A Chip Off the Old Block</span>
</li>
<li id="toc-li-22">
<span href="#/text/ch022#sanctuary" title="Link target outside of Sample">Sanctuary</span>
</li>
<li id="toc-li-23">
<span href="#/text/ch023#a-question-of-conscience" title="Link target outside of Sample">A Question of Conscience</span>
</li>
<li id="toc-li-24">
<span href="#/text/ch024#a-confrontation" title="Link target outside of Sample">A Confrontation</span>
</li>
<li id="toc-li-25">
<span href="#/text/ch025#a-watch" title="Link target outside of Sample">A Watch</span>
</li>
<li id="toc-li-26">
<span href="#/text/ch026#father-and-son" title="Link target outside of Sample">Father and Son</span>
</li>
<li id="toc-li-27">
<span href="#/text/ch027#a-striking-window-display" title="Link target outside of Sample">A Striking Window Display</span>
</li>
<li id="toc-li-28">
<span href="#/text/ch028#the-door-that-led-nowhere" title="Link target outside of Sample">The Door That Led Nowhere</span>
</li>
<li id="toc-li-29">
<span href="#/text/ch029#ascending-the-dome" title="Link target outside of Sample">Ascending the Dome</span>
</li>
<li id="toc-li-30">
<span href="#/text/ch030#less-than-perfect-fathers" title="Link target outside of Sample">Less Than Perfect Fathers</span>
</li>
<li id="toc-li-31">
<span href="#/text/ch031#the-experiment" title="Link target outside of Sample">The Experiment</span>
</li>
<li id="toc-li-32">
<span href="#/text/ch032#an-interest-in-keys" title="Link target outside of Sample">An Interest in Keys</span>
</li>
<li id="toc-li-33">
<span href="#/text/ch033#a-world-of-provision" title="Link target outside of Sample">A World of Provision</span>
</li>
<li id="toc-li-34">
<span href="#/text/ch034#next-in-series" title="Link target outside of Sample">Next in Series</span>
</li>
<li class="author_bio">
<span href="#/text/author_bio" title="Link target outside of Sample">About the Author</span>
</li>
<li class="also_by">
<span href="#/text/also_by" title="Link target outside of Sample">Also by R. N. Morris</span>
</li>
<li id="toc-li-35">
<span href="#/text/ch035#copyright" title="Link target outside of Sample">Copyright</span>
</li>
</ol>
</nav>
<nav epub:type="landmarks" hidden="hidden" id="landmarks">
<ol>
<li>
<span epub:type="cover" href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li>
<a epub:type="toc" href="#/nav#toc">Table of Contents</a>
</li>
<li>
<a epub:type="bodymatter" href="#/text/title_page">Start of Content</a>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?d0e8adf8